import { useCallback } from 'react';
import { ResourceRef } from 'api/types';
import { fileCacheStore } from 'state/store';
import { selectCachedFile } from 'state/selectors';
import { useEncryption } from 'useCase/encryption/useEncryption';

const inProgress = new Map<string, Promise<string>>();

export const useCache = () => {
    const { getAndEncryptImage } = useEncryption();

    const getCachedImage = useCallback((ref?: ResourceRef): Promise<string> | string => {
        if (!ref || !ref.url || !ref.id) {
            return '';
        }

        // check cache
        const cachedFile = selectCachedFile(ref);

        if (cachedFile !== undefined) {
            inProgress.delete(ref.id);
            return cachedFile;
        }

        // check is file in process of encoding
        const cachedInProgress = inProgress.get(ref.id);
        if (cachedInProgress) {
            return cachedInProgress;
        }

        const fileOrPromise = getAndEncryptImage(ref);
        const promiseForUrl = fileOrPromise
            .then(async (fileData) => {
                const url = fileData || '';
                fileCacheStore.addCachedFile(ref.id, url);
                return url;
            })
            .catch((e) => {
                console.error(e);
                return '';
            })
            .finally(() => {
                inProgress.delete(ref.id);
            });

        inProgress.set(ref.id, promiseForUrl);

        return promiseForUrl;
    }, []);

    return { getCachedImage };
};
